import type { AssignmentJob } from '../AssignmentJob';
import type { Assignment } from '../Assignment';
import { getStatus } from '../../../utilities/getStatus';

export class DeliveriesMenuActions {
    public static deliveryCanBeRejected(
        assignmentJob: AssignmentJob,
        assignment: Assignment
    ): boolean {
        return (
            assignment.isDefault() &&
            (this.assignmentJobIsAssigned(assignmentJob, assignment) ||
                assignmentJob.getAssignmentId() !== 0 ||
                (assignmentJob.getId() === 0 && assignmentJob.getAssignmentId() === 0)) &&
            !this.assignmentJobHasBeenDownloaded(assignmentJob, assignment)
        );
    }

    public static deliveryCanBeAssigned(
        assignmentJob: AssignmentJob,
        assignment: Assignment
    ): boolean {
        return (
            assignment.isDefault() &&
            assignment.getVehicleName() !== '' &&
            !this.assignmentJobIsAssigned(assignmentJob, assignment) &&
            !this.assignmentJobIsLocked(assignmentJob, assignment)
        );
    }

    public static assignmentJobIsAssigned(
        assignmentJob: AssignmentJob,
        assignment: Assignment
    ): boolean {
        return (
            (assignment.isDefault() && assignment.getId() === assignmentJob.getAssignmentId()) ||
            assignmentJob.getAssignmentId() !== 0
        );
    }

    public static deliveryHasSuggestion(
        assignmentJob: AssignmentJob,
        assignment: Assignment
    ): boolean {
        return assignmentJob.getSuggestedAssignmentId() === assignment.getId();
    }

    public static isRoutePointApproached(assignmentJob: AssignmentJob | null): boolean {
        if (!assignmentJob) {
            return false;
        }
        return typeof assignmentJob.getRoutePoint()?.details?.approached === 'number';
    }

    public static isRoutePointCompleted(assignmentJob: AssignmentJob | null): boolean {
        if (!assignmentJob) {
            return false;
        }
        return typeof assignmentJob.getRoutePoint()?.details?.completed === 'number';
    }

    public static isRoutePointCurrent(assignmentJob: AssignmentJob | null): boolean {
        if (!assignmentJob) {
            return false;
        }
        return (assignmentJob.getRoutePoint()?.details?.status || '') === 'current';
    }

    public static assignmentJobIsLocked(assignmentJob: AssignmentJob, assignment: Assignment) {
        return assignment.isLocked() && assignment.getId() === assignmentJob.getAssignmentId();
    }

    public static assignmentJobHasBeenDownloaded(assignmentJob: AssignmentJob, assignment: Assignment) {
        return (assignment.isDownloaded() || assignment.isRouteModifiedAfterDownload()) && assignment.getId() === assignmentJob.getAssignmentId();
    }

    public static hasAssignment(assignmentJob: AssignmentJob) {
        return assignmentJob.getAssignmentId() > 0;
    }

    public static deliveryCanBeChecked(assignmentJob: AssignmentJob, assignment: Assignment) {
        // return getStatus(assignmentJob.getJob()) <= 60;
        let shouldCheckboxBeDisabled =
            assignment.getId() === assignmentJob.getAssignmentId() &&
            (assignment.isLocked() || assignment.isRouteModifiedAfterDownload());
        return !shouldCheckboxBeDisabled && getStatus(assignmentJob.getJob()) <= 60;
    }

    public static deliveryCanBeAssignedToAnotherVehicle(
        assignmentJob: AssignmentJob,
        assignment: Assignment
    ) {
        return (
            !assignmentJob.isBusy() &&
            !DeliveriesMenuActions.isRoutePointApproached(assignmentJob) &&
            !DeliveriesMenuActions.assignmentJobIsLocked(assignmentJob, assignment)
        );
    }
}
